import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiError } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, object = logged in
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                if (mounted) setUser(data);
            } catch {
                if (mounted) setUser(false);
            } finally {
                if (mounted) setLoading(false);
            }
        })();
        return () => {
            mounted = false;
        };
    }, []);

    async function login(username, password) {
        try {
            const { data } = await api.post("/auth/login", { username, password });
            if (data.token) localStorage.setItem("wmf_token", data.token);
            setUser(data.user);
            return { ok: true, must_change: !!data.user?.must_change };
        } catch (e) {
            return { ok: false, error: formatApiError(e) };
        }
    }

    async function logout() {
        try {
            await api.post("/auth/logout");
        } catch (err) {
            console.warn("Logout API call failed (continuing with local cleanup):", err);
        }
        localStorage.removeItem("wmf_token");
        setUser(false);
    }

    return (
        <AuthCtx.Provider value={{ user, loading, login, logout, setUser }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
